var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-toggle",on:{"click":_vm.emitValue}},[_c('img',{attrs:{"src":_vm.toggleImg}}),_c('h3',{class:{
        'circle-label': true,
        'circle-label-selected': _vm.value
      }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }